// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3s7fk","left":"styles_left__3orAi","desktopActions":"styles_desktopActions__1gwdI","title":"styles_title__3KFVO"};